import { useViewport } from 'contexts/viewportContext';
import { useRights } from 'hooks/useRights';
import { MIN_SCREEN_WIDTH } from './utils';

export const getUploadedOmitActions = () => {
  const rights = useRights();
  const omitActions = [];

  if (!rights.edit && !rights.ownEdit) {
    omitActions.push('edit');
  }

  if (!rights.delete && !rights.ownDelete) {
    omitActions.push('delete');
  }

  return omitActions;
};

export const getCommonOmitActions = () => {
  const rights = useRights();
  const { width } = useViewport();
  const omitActions = [];
  //   const isAdaptiveModeOn = window.innerWidth < MIN_SCREEN_WIDTH;
  const isAdaptiveModeOn = width <= MIN_SCREEN_WIDTH;

  if (!rights.edit) {
    omitActions.push('edit');
  }

  if (!rights.delete) {
    omitActions.push('delete');
  }

  if (!rights.toAdmin) {
    omitActions.push('toAdmin');
  }

  if (!rights.toUpload || isAdaptiveModeOn) {
    omitActions.push('toUpload');
  }

  return omitActions;
};
